// Register ScrollTrigger
gsap.registerPlugin(ScrollTrigger);

const blockTexts = document.querySelectorAll('.animated-block__text');

// Check if the current page is the "Woods" page
const isWoodsPage = document.body.classList.contains('page-product-bundles-woods');

// Check if the current page is the "Woods" page
const isDriversPage = document.body.classList.contains('page-product-bundles');

// Check if the current page is the "Three Driver Graph A" page
const isThreeDriverGraphAPage = document.body.classList.contains('page-page-three-driver-graph-a');

// Check if the current page is the "Science" page
const isDriverSciencePage = document.body.classList.contains('page-page-science-behind-fire-tech');

// Create a timeline for each block to control the order of animations
blockTexts.forEach((blockText) => {
  const childNodes = blockText.childNodes; // Get all child nodes (including span elements)

  const spanList = Array.from(childNodes).map(node => {
    if (node.nodeType === Node.TEXT_NODE) {
      return node.textContent.split(' ').filter(w => w.trim().length > 0).map(w => `<span>${w}</span>`).join(' ');
    } else if (node.nodeType === Node.ELEMENT_NODE && node.classList.contains('span-kgtype')) {
      return Array.from(node.childNodes).map(innerNode => {
        if (innerNode.nodeType === Node.ELEMENT_NODE && innerNode.classList.contains('white')) {
          return innerNode.textContent.split(' ').map(word => `<span class="white span-kgtype">${word}</span>`).join(' ');
        } else if (innerNode.nodeType === Node.TEXT_NODE) {
          return innerNode.textContent.split(' ').map(word => `<span class="span-kgtype">${word}</span>`).join(' ');
        }
      }).join(' ');
    } else {
      return node.outerHTML; // Preserve other elements as is
    }
  }).join(' ');

  blockText.innerHTML = spanList;

  // Default ScrollTrigger settings
  const scrollTriggerSettings = {
    trigger: blockText.closest('.animated-block'),
    start: 'top 25%', // Default start position
    end: 'bottom top', // Default end position
    scrub: true,
    pin: true,
  };

  // Adjust ScrollTrigger settings for the Woods page
  if (isWoodsPage) {
    scrollTriggerSettings.start = 'top 50%';
    scrollTriggerSettings.end = 'bottom center';
  }
  5
  // Adjust ScrollTrigger settings for the Drivers page
  if (isDriversPage) {
    scrollTriggerSettings.start = 'top 15%';
  }

  // Adjust ScrollTrigger settings for the "Three Driver Graph A" page
  if (isThreeDriverGraphAPage) {
    scrollTriggerSettings.start = 'top 10%';
    scrollTriggerSettings.end = 'bottom top';
  }
  // Disable pinning for mobile (below 832px) on "Three Driver Graph A" page
  const isMobile = window.matchMedia("(max-width: 832px)").matches;
  if (isThreeDriverGraphAPage && isMobile) {
    scrollTriggerSettings.pin = false;  // This prevents text blocks from overlapping
    scrollTriggerSettings.start = 'top 230%';
  }

  // Adjust ScrollTrigger settings for the "Driver Science" page
  if (isDriverSciencePage) {
    scrollTriggerSettings.start = 'top 5%';
    scrollTriggerSettings.end = 'bottom top';
  }

  // Create a timeline with the adjusted ScrollTrigger settings
  const tl = gsap.timeline({
    scrollTrigger: scrollTriggerSettings,
  });

  // Add the text animation to the timeline, excluding .a.kbtn
  tl.from(blockText.querySelectorAll('span:not(.a.kbtn)'), {
    opacity: 0.2,
    stagger: 0.5,
  });

  // Ensure .a.kbtn stays at 100% opacity
  const kbtn = blockText.querySelector('.a.kbtn');
  if (kbtn) {
    gsap.set(kbtn, { opacity: 1 });
  }

  // Select the corresponding '.kgtype-p-outer' for this animated block
  const kgtypeDiv = blockText.closest('.animated-block').querySelector('.kgtype-p-outer');

  // Ensure we have found the correct kgtypeDiv before applying the animation
  if (kgtypeDiv) {
    // Add the fade-in animation for the '.kgtype-p-outer' div after the h2 animation finishes
    tl.from(kgtypeDiv, {
      opacity: 0.3,            // Starts from invisible
      duration: 3,           // Animation duration
      ease: 'power2.out',    // Smooth ease
    });
  }

  // Add fade-in for the images to start 0.5 seconds before text fade-in finishes
  const imageBoxes = blockText.closest('.animated-block').querySelectorAll('.image-boxes > div');

  // Ensure we found the images and add fade-in animation
  if (imageBoxes) {
    tl.from(imageBoxes, {
      opacity: 0,
      duration: 6,
      stagger: 1,
      ease: 'power2.out',
    }, "-=1");
  }
});


// Ensure ScrollTrigger updates when accordions expand or collapse
document.addEventListener("DOMContentLoaded", () => {
  const accordions = document.querySelectorAll('.product__accordion');

  accordions.forEach(accordion => {
    accordion.addEventListener('click', () => {
      // Wait for the transition to complete, then refresh ScrollTrigger
      setTimeout(() => {
        ScrollTrigger.refresh();
      }, 500); // Adjust timing based on animation speed
    });
  });
});

